export default __webpack_public_path__ + "static/media/2.6af4f199.jpg";